export enum EGanttTaskType {
	task = 'task',
	milestone = 'milestone',
}

export enum EViewMode {
	Hour = 'Hour',
	QuarterDay = 'Quarter Day',
	HalfDay = 'Half Day',
	Day = 'Day',
	/** ISO-8601 week */
	Week = 'Week',
	Month = 'Month',
	QuarterYear = 'QuarterYear',
	Year = 'Year',
}
